import { render, staticRenderFns } from "./productionSearch.vue?vue&type=template&id=fcfa74ec&scoped=true"
import script from "./productionSearch.vue?vue&type=script&lang=js"
export * from "./productionSearch.vue?vue&type=script&lang=js"
import style0 from "./productionSearch.vue?vue&type=style&index=0&id=fcfa74ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfa74ec",
  null
  
)

export default component.exports